// if (!customElements.get('product-form')) {
//   customElements.define('product-form', class ProductForm extends HTMLElement {
//     constructor() {
//       super();

//       this.form = this.querySelector('form');
//       this.form.querySelector('[name=id]').disabled = false;
//       this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//       this.cartNotification = document.querySelector('cart-notification');
//     }

//     onSubmitHandler(evt) {
//       evt.preventDefault();
//       const submitButton = this.querySelector('[type="submit"]');
//       if (submitButton.classList.contains('loading')) return;

//       this.handleErrorMessage();
//       this.cartNotification.setActiveElement(document.activeElement);

//       submitButton.setAttribute('aria-disabled', true);
//       submitButton.classList.add('loading');
//       this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

//       const config = fetchConfig('javascript');
//       config.headers['X-Requested-With'] = 'XMLHttpRequest';
//       delete config.headers['Content-Type'];

//       const formData = new FormData(this.form);
//       formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => secection.id));
//       formData.append('sections_url', window.location.pathname);
//       config.body = formData;

//       fetch(`${routes.cart_add_url}`, config)
//         .then((response) => response.json())
//         .then((response) => {
//           if (response.status) {
//             this.querySelector('.wbquicksuccess').classList.add('hidden'); // Webibazaar Quickview Message
//             this.handleErrorMessage(response.description);
//             return;
//           }

//           this.cartNotification.renderContents(response);
//           this.querySelector('.wbquicksuccess').classList.remove('hidden'); // Webibazaar Quickview Message
//         })
//         .catch((e) => {
//           console.error(e);
//         })
//         .finally(() => {
//           submitButton.classList.remove('loading');
//           submitButton.removeAttribute('aria-disabled');
//           this.querySelector('.loading-overlay__spinner').classList.add('hidden');

//         });
//     }

//     handleErrorMessage(errorMessage = false) {
//       this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//       this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//       this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//       if (errorMessage) {
//         this.errorMessage.textContent = errorMessage;
//       }
//     }
//   });
// }



if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    onSubmitHandler(evt) {
      evt.preventDefault(); // Stop Page Reload
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const formData = new FormData(this.form);
      formData.append('sections', 'header'); // Tell Shopify to update the Header
      formData.append('sections_url', window.location.pathname);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          alert(response.description);
          return;
        }

        // Update Header & Force Dropdown Open
        if (response.sections && response.sections.header) {
          const html = new DOMParser().parseFromString(response.sections.header, 'text/html');
          
          // 1. Update Cart Count Bubble
          const newCount = html.querySelector('#Cartcount');
          const currentCount = document.querySelector('#Cartcount');
          if (newCount && currentCount) currentCount.textContent = newCount.textContent;

          // 2. Update Dropdown List Content
          const newDropdown = html.querySelector('#cart-icon-bubble .dropdown-menu');
          const currentDropdown = document.querySelector('#cart-icon-bubble .dropdown-menu');
          
          if (newDropdown && currentDropdown) {
            currentDropdown.innerHTML = newDropdown.innerHTML;
            
            // Remove "Empty" styling
            currentDropdown.classList.remove('is-empty');
            document.querySelector('#cart-icon-bubble')?.classList.remove('is-empty');
            document.querySelectorAll('.is-empty').forEach(el => el.classList.remove('is-empty'));

            // 3. AUTO-OPEN THE DROPDOWN
            const cartWrapper = document.querySelector('#cart-icon-bubble');
            if (cartWrapper) {
                cartWrapper.classList.add('show');
                currentDropdown.classList.add('show');
                currentDropdown.style.display = 'block'; // Force visibility
            }
          }
        }

        // Show Webibazaar Success Message
        const successMsg = this.querySelector('.wbquicksuccess');
        if (successMsg) successMsg.classList.remove('hidden');
      })
      .catch((e) => console.error(e))
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      });
    }
  });
}